import { SVGProps } from 'react';

interface IProps extends SVGProps<SVGSVGElement> {
	active?: boolean;
}

export const AddIcon = ({ active, ...rest }: IProps) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M19.0711 12H4.92893" 
			stroke={active ? '#140F33' : '#646174'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 4.92896V19.0711" 
			stroke={active ? '#140F33' : '#646174'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);


